import DOIRequestTable from "./DOITable/doiTable";
import SideNavigation from "../Common/sideNavigation";

/**
 * Returns the DOI Requests page component.
 *
 * @returns The DOI Requests page component.
 */
const DOIRequest = () => {

  return (
    <>
      <div className="flex flex-col h-fit md:h-screen">
        <div className="h-full bg-gray-50">
          <SideNavigation />

          <main className="lg:pl-72 bg-gray-50 h-full">
            <div className="">
              <div className="px-4 py-10 sm:px-6 lg:px-8 lg:py-6">

                <DOIRequestTable />

              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default DOIRequest;